<template>
  <div class="main-product-card-container">

    <!-- Контейнер для фото -->
    <div class="product-photo-container">
      <!-- Фото товара -->
        <img
            :src="product.photo_url"
            alt=""
            class="main-product-image"
            @click="openModal"
        />
        
        <!-- Контенер таблица размеров и название товара -->
        <div class="p-name-size-container">
            <!-- Название товара -->
            <div class="product-name" @click="openSizeTableModal">{{ product.product_name }}</div>

            <!-- Таблица размеров -->
            <div class="product-size-table" v-if="hasSizeTable" @click="openSizeTableModal">Таблица размеров</div>
        </div>

        <!-- Переключатель партий (показываем только если партий больше одной) -->
        <div class="batch-switcher" v-if="batches.length > 1">
            <button
                v-for="batch in batches"
                :key="batch.id"
                class="batch-pill"
                :class="{ active: batch.id === selectedBatchId }"
                @click="selectedBatchId = batch.id"
            >
                {{ batch.label || `Партия #${batch.id}` }}
            </button>
        </div>

        <!-- Слайдер с размерами -->
        <SizeSlider
          :key="selectedBatchId"
          :product-name="product.product_name"
          :product-photo="product.photo_url"
          :product-sizes="selectedPresenceDict"
          :drop-price="selectedBatchPrices.dropPrice"
          :retail-price="selectedBatchPrices.retailPrice"
          :is-drop-product="product.is_drop"
          :is-from-abroad="product.is_from_abroad"
          :batch-id="selectedBatchId"
          :on-return="product.on_return || {}"
        />

        <!-- Основной блок информации о продукте -->
        <ProductData
          :drop-price="selectedBatchPrices.dropPrice"
          :retail-price="selectedBatchPrices.retailPrice"
          :product-presence="selectedPresenceDict"
          :on-return="product.on_return || {}"
          :is-drop-product="product.is_drop"
          :photo-pack-url="product.photo_pack_url"
          :is-from-abroad="product.is_from_abroad"
        />

    </div>

    <!-- Модальное окно (фото товара) -->
    <div v-if="isModalOpen" class="modal" @click="closeModal">
      <img :src="product.photo_url" alt="Большое фото" class="modal-image">
    </div>

    <!-- Модальное окнро (таблица размеров) -->
    <div v-if="isSizeTableModalOpen" class="modal">
      <!-- Здесь будет таблица с размерами -->
      <!-- TODO: сделать таблицу с размерами активную -->
      <img src="../assets/icons/close (1).png" alt="" class="close-icon" @click="closeSizeTableModal">
      <SizeTableCard :table-data="selectedBatchPrices.sizeTable"/>
    </div>
  </div>
</template>

<script>
import SizeSlider from '../components/SizeSlider.vue';
import ProductData from '../components/ProductData.vue';
import SizeTableCard from '../components/modal-windows/SizeTableCard.vue';
import api from '@/api/api';

export default {
  components: {
    SizeSlider,
    ProductData,
    SizeTableCard,
  },
  data() {
    return {
      isModalOpen: false,
      isSizeTableModalOpen: false,

      // Данные о продукте
      product: {},
      // Выбранная клиентом партия (по умолчанию — ведущая)
      selectedBatchId: null,
    };
  },

  computed: {
    batches() {
      return this.product.batches || [];
    },
    selectedBatch() {
      return this.batches.find(b => b.id === this.selectedBatchId)
          || this.batches.find(b => b.is_leading)
          || this.batches[0]
          || null;
    },
    // Приводим presence партии ({size_id, size_name, quantity}[]) к формату
    // {size_name: quantity}, который ждут SizeSlider/ProductData
    selectedPresenceDict() {
      if (!this.selectedBatch) return this.product.presence || {};
      return (this.selectedBatch.presence || []).reduce((acc, p) => {
        acc[p.size_name] = p.quantity;
        return acc;
      }, {});
    },
    hasSizeTable() {
      const sizeTable = this.selectedBatchPrices.sizeTable;
      return Array.isArray(sizeTable) && sizeTable.length > 0;
    },
    selectedBatchPrices() {
      if (!this.selectedBatch) {
        return {
          dropPrice: this.product.drop_price,
          retailPrice: this.product.retail_price,
          sizeTable: this.product.size_table,
        };
      }
      return {
        dropPrice: this.selectedBatch.drop_price,
        retailPrice: this.selectedBatch.retail_price,
        sizeTable: this.selectedBatch.size_table,
      };
    },
  },

  props: {
    productId: {
      type: String,
      required: true,
    },
    // Пропс для фото (в целях ускорения работы приложения)
    productPhoto: {
      type: String,
      required: false,
    },
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    openSizeTableModal() {
      if (!this.hasSizeTable) return;
      this.isSizeTableModalOpen = true;
      
      if (window.Telegram && window.Telegram.WebApp) {
            const backButton = window.Telegram.WebApp.BackButton.show();
            
            backButton.onClick(() => {
              this.isSizeTableModalOpen = false;
              this.showBackButton();
            });
      }
    },
    // TODO: в production версии убрать эту функцию (она будет заменена кнопкой из TG API BackButton)
    closeSizeTableModal() {
      this.isSizeTableModalOpen = false;
    },

    showBackButton() {
        if (window.Telegram && window.Telegram.WebApp) {
            const backButton = window.Telegram.WebApp.BackButton.show();

            backButton.onClick(() => {
                window.Telegram.WebApp.MainButton.hide();
                backButton.hide();
                this.$router.back();
            });
        }
    },

    // Получаем нужный товар с сервера по id
    async fetchProduct() {
        try {
            const response = await api.get(`/products/${this.productId}`);
            console.log(response); // тут объект ответа от axios
            this.product = response.data; // данные лежат тут
            this.selectedBatchId = response.data.leading_batch_id
                || (response.data.batches && response.data.batches[0] && response.data.batches[0].id)
                || null;
        } catch (error) {
            console.error("Ошибка при загрузке данных:", error);
        }
    },

  },
  created() {
    this.showBackButton();

  }, 
  mounted() {
    this.fetchProduct();

    console.log('📦 product:', this.product);

  },
};
</script>

<style scoped>
.main-product-card-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.main-product-image {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  opacity: 0.8;
  cursor: pointer; /* Чтобы было понятно, что фото кликабельно */
  position: fixed
}

.product-photo-container {
  position: relative;
  height: 185vw;
}

.p-name-size-container {
  display: grid;
  grid-template-columns: 5fr 3fr;
  position: absolute;
  bottom: 55vw;
  padding: 0 4vw;
  font-family: 'Inter', sans-serif;
  color: white;
}

.product-name {
  font-weight: 900;
  font-size: 28px;
  line-height: 1.2;
}

.product-size-table {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: white;
  height: 50%;
  align-self: end;
  margin-bottom: -5%;
}

/* Полоска партий в стиле полоски размеров (SizeSlider), сверху — под шапкой Telegram */
.batch-switcher {
  position: absolute;
  top: calc(var(--tg-safe-area-inset-top, 0px) + var(--tg-content-safe-area-inset-top, 0px) + 2vw);
  left: 0;
  width: 100%;
  display: flex;
  gap: 2vw;
  padding: 0 4vw;
  overflow-x: auto;
  backdrop-filter: blur(2px);
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
}

.batch-switcher::-webkit-scrollbar { /* Chrome, Safari, Opera */
  display: none;
}

.batch-pill {
  flex: 1 0 28vw;
  height: 10vw;
  padding: 0 3vw;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.3s, background-color 0.3s;
}

.batch-pill.active {
  border-color: #0BDA51;
  background-color: rgba(255, 255, 255, 0.3);
}

/* Стили для модального окна */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
  object-fit: contain;
}

.close-icon {
  position: absolute;
  top: 30vw;
  left: 20px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 1001; /* чтобы иконка была поверх модального окна */
}
</style>
